<template>

    <ModalAddAplicacao :isVisible="isVisibleModalAddApp" @close="isVisibleModalAddApp = false"></ModalAddAplicacao>

    <ModalEditAplicacao :aplicacao="aplicacaoEdit" :isVisible="isVisibleModalEditApp" @close="isVisibleModalEditApp = false"></ModalEditAplicacao>

    <ModalVerCobrancasApp :aplicacao="aplicacaoModalVercobrancas" :isVisible="isVisibleModalVerCobrancas"
        @close="isVisibleModalVerCobrancas = false"></ModalVerCobrancasApp>
    
    <ModalFichaTecnicaApp :aplicacao="appFfichaTecnica" :isVisible="isVisibleModalFichaTecnica"
        @close="isVisibleModalFichaTecnica = false"></ModalFichaTecnicaApp>


    <div class="d-flex">

        <NavBarLeft path="/app"></NavBarLeft>

        <div class="flex-1">

            <HeaderPage title="Aplicações" subtitle="Gerenciamento de aplicações"></HeaderPage>

            <div class="m-2 p-2 bg-white">
                <div class="mb-2 text-end d-flex gap-1 justify-content-end">

                    <ButtonField @click="isVisibleModalAddApp = true" icon="ri-add-line" type="success" size="small"
                        text="Adicionar Aplicação"></ButtonField>

                </div>

                <BaseTable :columns="dataTableHead" :rows="aplicacoesStore.aplicacoes"
                    :paginationOptions="{ perPage: 50 }">

                    <template #table-row="{ column, row }">

                        <!-- Coluna de Ações -->
                        <template v-if="column.field == '__actions'">

                            <span>
                                <DropdownFloating v-model:shown="row.dropdownShown" :distance="6"
                                    placement="left-start">

                                    <div class="">
                                        <i class="ri-more-fill cursor-pointer"></i>
                                    </div>


                                    <template #popper>
                                        <div class="p-2 d-flex gap-2 flex-column">

                                            <OptionActionDataTable @click="openModalEditAplicacao(row)" text="Editar" icon="ri-pencil-line">
                                            </OptionActionDataTable>

                                            <OptionActionDataTable @click="openModalCobrancasApp(row)" text="Cobranças"
                                                icon="ri-money-dollar-circle-line">
                                            </OptionActionDataTable>

                                            <OptionActionDataTable v-if="authStore.usuario.root && row.status != 'INSTALANDO' && !row.instalado" @click="forcarInstall(row)" text="Forçar Instalação"
                                                icon="ri-play-line">
                                            </OptionActionDataTable>

                                            <OptionActionDataTable v-if="authStore.usuario.root && row.instalado" @click="getFichaTecnicaApp(row)" text="Ficha Técnica"
                                                icon="ri-file-list-2-line">
                                            </OptionActionDataTable>

                                            <OptionActionDataTable v-if="row.instalado" @click="acessarApp(row)" text="Acessar Aplicação"
                                                icon="ri-login-box-line">
                                            </OptionActionDataTable>

                                            <OptionActionDataTable v-if="authStore.usuario.root" @click="deletarAplicacao(row)" text="Deletar"
                                                icon="ri-delete-bin-line" textColor="danger">
                                            </OptionActionDataTable>

                                        </div>
                                    </template>
                                </DropdownFloating>
                            </span>

                        </template>

                        <!-- Colunas de status -->
                        <template v-else-if="column.field == 'status'">

                            <BadgeField v-if="row.status == 'ATIVO'" type="success" text="Ativo" :rounded="true">
                            </BadgeField>

                            <BadgeField v-else-if="row.status == 'AGUARDANDO_PAGAMENTO'" type="danger"
                                text="Aguardando Pagamento" :rounded="true">
                            </BadgeField>


                            <BadgeField v-else-if="row.status == 'inactive'" type="warning" text="Inativo"
                                :rounded="true">
                            </BadgeField>

                            <BadgeField icon="ri-refresh-line rotate" v-else-if="row.status == 'INSTALANDO'" type="info"
                                text="Instalando" :rounded="true">
                            </BadgeField>

                        </template>

                        <!-- Colunas de parceria -->
                        <template v-else-if="column.field == 'parceria'">
                            {{ (row.parceria) ? row.parceria.nome : '-' }}
                        </template>

                        <!-- Colunas de URL -->
                        <template v-else-if="column.field == 'url'">
                            <template v-if="row.instalado">
                                <a style="color: deepskyblue;text-decoration: underline !important;" :href="row.url" target="_blank">{{ row.url }}</a>
                            </template>

                            <template v-else>
                                {{ row.url }}
                            </template>
                        </template>

                        <!-- Colunas de Progresso de instalção -->
                        <template v-else-if="column.field == 'progresso_install'">
                            <ProgressBar :value="row.progresso_install" max="100"></ProgressBar>
                        </template>

                        <!-- Colunas normais -->
                        <template v-else>
                            {{ row[column.field] }}
                        </template>
                    </template>

                </BaseTable>

            </div>

        </div>

    </div>
</template>


<script>

import { useAplicacoesStore } from '@/stores/aplicacoes.js'
import { useAuthStore } from '@/stores/auth.js';

import ModalAddAplicacao from '@/components/modais/ModalAddAplicacao.vue';
import ModalVerCobrancasApp from '@/components/modais/ModalVerCobrancasApp.vue';
import { toast } from 'vue3-toastify'

import SocketService from '@/services/SocketService';
import ModalEditAplicacao from '@/components/modais/ModalEditAplicacao.vue';
import ModalFichaTecnicaApp from '@/components/modais/ModalFichaTecnicaApp.vue';

export default {
    name: 'AppPage',
    data() {
        return {

            dataTableHead:
                [
                    { label: 'Nome', field: 'nome', tdClass: 'td-vertical-middle' },
                    { label: 'Responsável', field: 'responsavel', tdClass: 'td-vertical-middle' },
                    { label: 'Parceria', field: 'parceria', tdClass: 'td-vertical-middle' },
                    { label: 'CNPJ/CPF', field: 'cnpj_cpf', tdClass: 'td-vertical-middle' },
                    { label: 'E-mail', field: 'email', tdClass: 'td-vertical-middle' },
                    { label: 'Telefone', field: 'telefone', tdClass: 'td-vertical-middle' },
                    { label: 'Status', field: 'status', tdClass: 'td-vertical-middle' },
                    { label: 'Progresso Instalação', field: 'progresso_install', tdClass: 'td-vertical-middle' },
                    { label: 'URL de acesso', field: 'url', tdClass: 'td-vertical-middle' },
                    { label: 'Ações', field: '__actions', sortable: false, tdClass: 'td-actions td-vertical-middle text-center' }
                ]
            ,

            isVisibleModalAddApp: false,
            aplicacoesStore: useAplicacoesStore(),
            authStore: useAuthStore(),


            isVisibleModalVerCobrancas: false,
            aplicacaoModalVercobrancas: {},

            isVisibleModalEditApp: false,
            aplicacaoEdit: {},


            appFfichaTecnica: {},
            isVisibleModalFichaTecnica: false,

        }
    },
    components: { ModalAddAplicacao, ModalEditAplicacao, ModalVerCobrancasApp, ModalFichaTecnicaApp },
    methods: {
        openModalCobrancasApp(aplicacao) {

            aplicacao.dropdownShown = false
            this.isVisibleModalVerCobrancas = true
            this.aplicacaoModalVercobrancas = aplicacao

        },
        openModalEditAplicacao(aplicacao){
            aplicacao.dropdownShown = false
            this.aplicacaoEdit = aplicacao
            this.isVisibleModalEditApp = true
        },
        async getFichaTecnicaApp(aplicacao){

            this.$notiflix.Loading.standard('Buscando Informações')
            aplicacao.dropdownShown = false

            const fichaTecnica = await this.aplicacoesStore.getFichaTecnica(aplicacao.id)
            this.appFfichaTecnica = fichaTecnica

            this.isVisibleModalFichaTecnica = true
            this.$notiflix.Loading.remove()

        },
        acessarApp(aplicacao){

            aplicacao.dropdownShown = false

            const login = aplicacao.login_axion_initial
            const senha = aplicacao.senha_axion_initial


            // cria o form
            const form = document.createElement("form");
            form.method = "POST";
            form.action = `${aplicacao.url}/administrador/controle/login/index.php`;
            form.target = "_blank"; // nova aba

            // adiciona os campos
            const data = {login, senha}
            for (const key in data) {
                
                const input = document.createElement("input");
                input.type = "hidden";
                input.name = key;
                input.value = data[key];
                form.appendChild(input);
                
            }

            // adiciona no body e dispara
            document.body.appendChild(form);
            form.submit();
            document.body.removeChild(form);

        },
        forcarInstall(aplicacao){
            aplicacao.dropdownShown = false
            this.$swal({
                title: 'Tem certeza?',
                text: `Você realmente deseja forçar a instalação dessa aplicação?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Cancelar',
            }).then(async (result) => {
                if (result.isConfirmed) {

                    
                    this.$notiflix.Loading.standard('Forçando Instalação da Aplicação')
                    const result = await this.aplicacoesStore.forcarInstall(aplicacao)
                    this.$notiflix.Loading.remove()

                    if (result.status) {
                        toast.success("Aplicação sendo instalada")
                    } else {
                        toast.error(result.message)
                    }
                }
            })
        },
        deletarAplicacao(aplicacao) {
            aplicacao.dropdownShown = false
            this.$swal({
                title: 'Tem certeza?',
                text: `Você realmente deseja deletar essa aplicação?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Cancelar',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    this.$notiflix.Loading.standard('Deletando Aplicação')
                    const result = await this.aplicacoesStore.delete(aplicacao)
                    this.$notiflix.Loading.remove()

                    if (result.status) {
                        toast.success("Aplicação deletada com sucesso")
                        this.aplicacoesStore.get()
                    } else {
                        toast.error(result.message)
                    }
                }
            })
        }
    },
    mounted() {
        this.aplicacoesStore.get()

        SocketService.connect()

        SocketService.on('update_app', (res) => {

            const index = this.aplicacoesStore.aplicacoes.findIndex(app => app.id == res.app.id)
            if (index != -1) this.aplicacoesStore.aplicacoes[index] = res.app

        })

        const params = new URLSearchParams(window.location.search);
        if(params.get('modalContratar') == 'true'){
            this.isVisibleModalAddApp = true
        }


    },
    beforeUnmount() {
        SocketService.disconnect()
    }
}
</script>